function numericId(id) {
    var _a;
    return (_a = id === null || id === void 0 ? void 0 : id.split('/').pop()) !== null && _a !== void 0 ? _a : '';
}
function pickVariant(product, variantId) {
    var _a, _b, _c;
    const normalizedVariantId = numericId(variantId);
    if (normalizedVariantId) {
        const matchingVariant = (_a = product.variants) === null || _a === void 0 ? void 0 : _a.find((variant) => numericId(variant.id) === normalizedVariantId);
        if (matchingVariant)
            return matchingVariant;
    }
    return (_b = product.selectedVariant) !== null && _b !== void 0 ? _b : (_c = product.variants) === null || _c === void 0 ? void 0 : _c[0];
}
function currentPrice(product, overrides) {
    var _a, _b, _c;
    return (_c = (_b = (_a = overrides.price) !== null && _a !== void 0 ? _a : product.price.sale) !== null && _b !== void 0 ? _b : product.price.special) !== null && _c !== void 0 ? _c : product.price.regular;
}
function compareAtPrice(product, overrides) {
    if (overrides.compareAtPrice !== undefined)
        return overrides.compareAtPrice;
    const price = currentPrice(product, overrides);
    return product.price.regular > price ? product.price.regular : undefined;
}
function currencyCode() {
    var _a, _b;
    return typeof window === 'undefined' ? 'AUD' : (_b = (_a = window.mrPLPConfig) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : 'AUD';
}
function round(value) {
    return Math.round(value * 100) / 100;
}
/** Maps a normalized Product into a native GA4 `items[]` entry. */
export function toElevarProduct(product, list, position, overrides = {}) {
    var _a, _b, _c, _d, _e;
    const variant = pickVariant(product, overrides.variantId);
    const productId = numericId((_a = overrides.productId) !== null && _a !== void 0 ? _a : product.id);
    const price = currentPrice(product, overrides);
    const wasPrice = compareAtPrice(product, overrides);
    return Object.assign(Object.assign({ item_id: overrides.sku || (variant === null || variant === void 0 ? void 0 : variant.sku) || product.sku || productId, item_name: (_b = overrides.name) !== null && _b !== void 0 ? _b : product.title, item_brand: (_c = overrides.brand) !== null && _c !== void 0 ? _c : product.brand, item_category: product.productType, item_variant: (_d = overrides.variantTitle) !== null && _d !== void 0 ? _d : variant === null || variant === void 0 ? void 0 : variant.title, price: round(price), item_list_id: list, item_list_name: list, fh_product_id: productId, fh_variant_id: numericId((_e = overrides.variantId) !== null && _e !== void 0 ? _e : variant === null || variant === void 0 ? void 0 : variant.id) }, (wasPrice !== undefined ? { discount: round(wasPrice - price) } : {})), (position !== undefined ? { index: position + 1 } : {}));
}
/**
 * GTM merges every push into one persistent model rather than replacing it, so a
 * later event inherits whatever `items` a previous one left behind. Nulling the
 * object first is Google's documented guard against that. Cleared on both queues
 * because Elevar forwards events, and this push deliberately carries no `event`
 * key — so it cannot be relied on to travel through Elevar.
 */
function clearEcommerce() {
    var _a, _b;
    (_a = window.ElevarDataLayer) === null || _a === void 0 ? void 0 : _a.push({ ecommerce: null });
    window.dataLayer = (_b = window.dataLayer) !== null && _b !== void 0 ? _b : [];
    window.dataLayer.push({ ecommerce: null });
}
function pushEvent(event, list, ecommerce, eventParams = {}) {
    var _a;
    if (typeof window === 'undefined')
        return;
    window.ElevarDataLayer = (_a = window.ElevarDataLayer) !== null && _a !== void 0 ? _a : [];
    clearEcommerce();
    window.ElevarDataLayer.push(Object.assign(Object.assign({ event, 
        // Custom event-scoped parameter, read by its own GTM data layer variable.
        fredhopper_list_id: list }, eventParams), { 
        // currency, item_list_id, item_list_name and items all belong inside
        // `ecommerce` — that is the only place GTM's ecommerce reader looks.
        ecommerce: Object.assign({ currency: currencyCode(), item_list_id: list, item_list_name: list }, ecommerce) }));
}
export function trackViewItemList(products, list) {
    if (!products.length)
        return;
    pushEvent('fh_view_item_list', list, {
        items: products.map((product, index) => toElevarProduct(product, list, index)),
    });
}
export function trackViewSearchResults(products, list, searchTerm) {
    if (!products.length)
        return;
    pushEvent('fh_view_search_results', list, { items: products.map((product, index) => toElevarProduct(product, list, index)) }, 
    // search_term is a plain event parameter, not ecommerce data.
    searchTerm ? { search_term: searchTerm } : {});
}
export function trackSelectItem(product, list, position, overrides = {}) {
    pushEvent('fh_select_item', list, {
        items: [toElevarProduct(product, list, position, overrides)],
    });
}
export function trackAddToCart(product, list, quantity = 1, overrides = {}) {
    // Not currently wired to BirdsnestProductCard's own add-to-cart. Birdsnest's
    // live Elevar config enables product_add_to_cart_ajax, so the card's
    // addToCart() already emits Elevar's add_to_cart via the intercepted
    // /cart/add.js. Under the `fh_` prefix that is no longer a duplicate event
    // name, so calling this alongside it would add Fredhopper attribution rather
    // than double-count — but that is a behaviour change, not done here.
    const item = Object.assign(Object.assign({}, toElevarProduct(product, list, undefined, overrides)), { quantity });
    pushEvent('fh_add_to_cart', list, {
        value: round(item.price * quantity),
        items: [item],
    });
}
